<div #tableWrapper class="siteTable__wrapper">
  @if (isTableLoading | async) {
    <div class="siteTable__overlay">
      <pp-spinner ppSize="large" aria-label="Site Table Overlay Spinner" />
    </div>
  }
  <div #table></div>
</div>
